import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

import { BookSection } from '../../../components/book-section/BookSection';
import LazyImage from '../../../components/common/LazyImage';
import { cn } from '../../../utils/classnames';
import { createTypographyHelper } from '../../../utils/typography';

import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getPageContents } from '../../../actions/admin/cmspage';
import FrontLayout from '../../../components/layout-new-theme/FrontLayout';
import { HanedaAirportTransfer, NaritaAirportTransfer } from './sections';

function AirportTransfer() {
  const { t, i18n } = useTranslation();

  const page_name = 'cms-index';

  const cmspage_state = useSelector((state) => state.cmspage);
  const dispatch = useDispatch();

  const { push, location } = useHistory();
  const search = new URLSearchParams(location.search);

  const tabList = [
    {
      id: 'haneda-airport',
      imageBanner:
        'https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/public_folder/cms-image/cms-airport-transfer/haneda-airport-transfer-banner.png',
    },
    {
      id: 'narita-airport',
      imageBanner:
        'https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/public_folder/cms-image/cms-airport-transfer/narita-airport-transfer-banner.png',
    },
  ];
  const [activeTab, setActiveTab] = useState(tabList[0]);

  const getTypographyClass = createTypographyHelper(i18n.language);

  useEffect(() => {
    const type = search.get('type');

    if (type === "HanedaAirportTransfer") {
      push(`?type=haneda-airport`)
    }

    if (type === "NaritaAirportTransfer") {
      push(`?type=narita-airport`)
    }

    if (type) {
      const selectedTab = tabList.find((tab) => tab.id === type);
      if (selectedTab) {
        setActiveTab(selectedTab);
      }
    }
  }, [location.search]);

  const kebabToPascal = (str) => {
    return str.replace(/(^|-)(\w)/g, (_, __, letter) => letter.toUpperCase()) + 'Transfer';
  };

  useEffect(() => {
    dispatch(getPageContents(page_name));
  }, [dispatch]);

  return (
    <FrontLayout>
      <div className="tw:relative tw:max-w-[1920px] tw:mx-auto tw:font-hanken-grotesk tw:mt-[88px]">
        <div className="tw:max-w-[1920px] tw:m-auto tw:relative">
          <div className="tw:bg-[linear-gradient(87.06deg,#000000_6.43%,rgba(40,42,45,0.3)_46.3%)] tw:w-full tw:h-full tw:absolute tw:top-0 tw:left-0 tw:z-20"></div>
          <LazyImage
            src={activeTab.imageBanner}
            alt="Narita Airport Transfer Banner"
            wrapperClassName="tw:w-full tw:h-[430px] tw:relative tw:z-0"
            className="tw:w-full tw:h-full tw:object-cover"
          />
          <div className="tw:absolute tw:left-5 tw:bottom-8 tw:lg:left-[82px] tw:lg:bottom-[65px] tw:space-y-[14px] tw:z-50">
            <div className="tw:text-[rgba(219,190,120,1)] tw:text-[8px] tw:tracking-[3px] tw:font-semibold tw:font-hanken-grotesk tw:leading-none tw:uppercase">
              {t(`AirportTransfer.${kebabToPascal(activeTab.id)}.Tag`)}
            </div>
            <div className="tw:text-[34px] tw:lg:text-[45px] tw:font-libre-caslon-display tw:leading-[58px] tw:text-white tw:font-normal">
              {t(`AirportTransfer.${kebabToPascal(activeTab.id)}.Title`)}
            </div>
            <div
              className={cn(
                'tw:flex tw:items-center tw:gap-x-3 tw:lg:gap-x-4 tw:flex-row tw:justify-start',
              )}
            >
              <span className="tw:font-semibold tw:text-[13px] tw:lg:text-[15px] tw:text-[#DADADA]">
                {t(`AirportTransfer.${kebabToPascal(activeTab.id)}.SubTitle`)}
              </span>
            </div>
          </div>
        </div>

        <div className="tw:sticky tw:top-[88px] tw:z-40 tw:mb-7 tw:lg:mb-[54px]">
          <div className="tw:bg-[#F9F9F9] tw:relative tw:border-b tw:border-b-[#8D8D8D] tw:h-[72px] tw:lg:h-[100px]">
            <div className="tw:flex tw:lg:px-[82px] tw:lg:justify-start tw:px-3 tw:pt-3 tw:lg:pt-[27px] tw:overflow-x-auto tw:whitespace-nowrap tw:absolute tw:w-full">
              {tabList.map((tab) => (
                <div
                  className={cn(
                    'tw:flex-1 tw:text-center tw:flex-shrink-0 tw:h-[60px] tw:lg:h-[73px] tw:px-5 tw:lg:px-[26px] tw:flex tw:items-center tw:justify-center tw:font-hanken-grotesk tw:lg:text-base tw:font-normal tw:lg:font-medium tw:space-x-2 tw:lg:space-x-3',
                    getTypographyClass(14),
                    activeTab.id === tab.id
                      ? 'tw:bg-white tw:border-x tw:border-x-[#8D8D8D] tw:border-t tw:border-t-[#8D8D8D] tw:text-[#282828] tw:rounded-tl-md tw:rounded-tr-md'
                      : 'tw:text-[#8D8D8D] tw:cursor-pointer',
                  )}
                  onClick={() => push(`?type=${tab.id}`)}
                  key={tab.id}
                >
                  <div>{t(`AirportTransfer.${kebabToPascal(tab.id)}.Title`)}</div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Render content based on active tab */}
        {activeTab.id === 'narita-airport' && <NaritaAirportTransfer />}
        {activeTab.id === 'haneda-airport' && <HanedaAirportTransfer />}

        <BookSection />
      </div>
    </FrontLayout>
  );
}

export default AirportTransfer;
